import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=4c9ce1bd&scoped=true&"
import script from "./CommonButton.vue?vue&type=script&lang=js&"
export * from "./CommonButton.vue?vue&type=script&lang=js&"
import style0 from "./CommonButton.vue?vue&type=style&index=0&id=4c9ce1bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9ce1bd",
  null
  
)

export default component.exports